import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { STATS } from "../mock/mock";

const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          obs.disconnect();
        }
      },
      { threshold: 0.18 }
    );
    const node = ref.current;
    if (node) obs.observe(node);
    return () => obs.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`reveal ${shown ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const PowerSection = () => {
  return (
    <section className="bg-white text-black">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-28 md:py-40">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.32em] text-black/55 mb-8">
            The Power of OOH
          </p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="font-display text-[14vw] md:text-[8vw] uppercase leading-[0.92]">
            The Power <br />
            <span className="font-serif-display italic font-black">to move.</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end">
          <Reveal delay={160} className="md:col-span-7">
            <p className="text-lg md:text-xl text-black/75 leading-relaxed max-w-2xl">
              Out-of-Home reaches India where it lives, works and moves. From the
              Western Express Highway to the Outer Ring Road, AMS turns the
              everyday commute into your stage.{" "}
              <span className="text-black">Built to do more than be seen.</span>
            </p>
          </Reveal>
          <Reveal delay={220} className="md:col-span-5 md:justify-self-end">
            <Link
              to="/about"
              className="group inline-flex items-center gap-3 text-sm uppercase tracking-[0.22em] font-semibold px-6 py-4 border border-black hover:bg-black hover:text-white transition-colors duration-200"
            >
              About AMS
              <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
            </Link>
          </Reveal>
        </div>

        {/* Stats Grid */}
        <div className="mt-24 md:mt-32 grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-6 md:gap-x-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 100}>
              <div className="md:border-l md:border-black/15 md:pl-6 first:md:border-l-0 first:md:pl-0">
                <div className="font-display text-5xl sm:text-6xl md:text-[5.5vw] lg:text-[5vw] leading-none whitespace-nowrap">
                  {s.value}
                </div>
                <div className="mt-4 text-xs md:text-sm uppercase tracking-[0.22em] font-semibold">
                  {s.label}
                </div>
                <div className="mt-2 text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-black/45">
                  {s.source}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PowerSection;
